import { Component } from '@angular/core';

@Component({
  selector: 'bwc-link-expired',
  templateUrl: './link-expired.component.html',
  styleUrls: ['./link-expired.component.scss'],
})
export class LinkExpiredComponent {}
